import { gql, TypedDocumentNode } from '@common/hooks';

type SupplierStaffingRequestFiltersQueryResponse = {
  organizationBusinesses: {
    id: string;
    name: string;
  }[];
  roles: {
    id: string;
    name: string;
  }[];
  worksClinicalUnits: {
    id: string;
    displayName: string;
  }[];
};

export const SupplierStaffingRequestFiltersQuery: TypedDocumentNode<SupplierStaffingRequestFiltersQueryResponse> = gql`
  query SupplierStaffingRequestFiltersQuery {
    organizationBusinesses {
      id
      name
    }
    roles {
      id
      name
    }
    worksClinicalUnits {
      id
      displayName
    }
  }
`;
